import { isEqualWith as i } from "./isEqualWith.js";
import { noop as t } from "../function/noop.js";
function p(o, r) {
  return i(o, r, t);
}
export { p as isEqual };